import React from 'react'

const FETUSD = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
      <path
        d='M37.6218 23.1589C37.8682 23.5277 37.9998 23.9615 37.9998 24.405C37.9998 25 37.7634 25.5706 37.3428 25.9914C36.9221 26.4118 36.3516 26.6482 35.7567 26.6482C35.313 26.6482 34.8794 26.5169 34.5104 26.2701C34.1417 26.0237 33.8541 25.6733 33.6843 25.2638C33.5145 24.8537 33.4702 24.4028 33.5567 23.9675C33.6433 23.5324 33.8568 23.1327 34.1707 22.8191C34.4843 22.5055 34.884 22.2919 35.3192 22.2052C35.7542 22.1187 36.2052 22.163 36.6151 22.333C37.0249 22.5027 37.3752 22.7902 37.6218 23.1589Z'
        fill='black'
      />
      <path
        d='M37.6218 34.5105C37.8682 34.8794 37.9998 35.3132 37.9998 35.7566C37.9998 36.3517 37.7634 36.9222 37.3428 37.343C36.9221 37.7633 36.3516 37.9997 35.7567 37.9997C35.313 37.9997 34.8794 37.8684 34.5104 37.6217C34.1417 37.3753 33.8541 37.025 33.6843 36.6153C33.5145 36.2054 33.4702 35.7545 33.5567 35.319C33.6433 34.884 33.8568 34.4844 34.1707 34.1708C34.4843 33.857 34.884 33.6436 35.3192 33.5567C35.7542 33.4703 36.2052 33.5146 36.6151 33.6846C37.0249 33.8542 37.3752 34.1417 37.6218 34.5105Z'
        fill='black'
      />
      <path d='M38 10.5059H32.6167V15.8891H38V10.5059Z' fill='black' />
      <path
        d='M26.4349 34.5105C26.6814 34.8794 26.8129 35.3132 26.8129 35.7566C26.8129 36.3517 26.5765 36.9222 26.1559 37.343C25.7352 37.7633 25.1647 37.9997 24.5698 37.9997C24.1261 37.9997 23.6926 37.8684 23.3236 37.6217C22.9548 37.3753 22.6673 37.025 22.4975 36.6153C22.3277 36.2054 22.2833 35.7545 22.3698 35.319C22.4564 34.884 22.67 34.4844 22.9837 34.1708C23.2974 33.857 23.697 33.6436 24.1322 33.5567C24.5673 33.4703 25.0183 33.5146 25.4282 33.6846C25.838 33.8542 26.1884 34.1417 26.4349 34.5105Z'
        fill='black'
      />
      <path d='M27.2617 21.7129H21.8785V27.0961H27.2617V21.7129Z' fill='black' />
      <path d='M27.4114 10.5059H21.729V16.1882H27.4114V10.5059Z' fill='black' />
      <path d='M16.505 10.5112H10.5236V16.4926H16.505V10.5112Z' fill='black' />
      <path d='M15.8892 32.6167H10.5059V38H15.8892V32.6167Z' fill='black' />
      <path d='M16.1882 21.5635H10.5059V27.2458H16.1882V21.5635Z' fill='black' />
    </svg>
  )
}

export default FETUSD
